'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)(this).find("[data-pagination]").each(initPagination);
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _navigator = require('../utils/navigator');

var _navigator2 = _interopRequireDefault(_navigator);

var _localize = require('../core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _flatten = require('lodash/flatten');

var _flatten2 = _interopRequireDefault(_flatten);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('DataTables');

function buttonTemplate(text, page, enabled, active) {
    var link = page && enabled ? '?page=' + page : 'javascript:void(0)';
    var classes = ['page-item'];
    if (active) classes.push('active');else if (!enabled) classes.push('disabled');
    return '<li class="' + classes.join(' ') + '"><a href="' + link + '">' + text + '</a></li>';
}

(0, _jquery2.default)(document).on('click', '[data-pagination] a', function () {
    var $this = (0, _jquery2.default)(this);
    var $dataContainer = (0, _jquery2.default)($this.closest('[data-pagination]').attr("data-pagination"));
    if (!$this.is('.disabled')) {
        setTimeout(function () {
            _jquery2.default.scrollTo($dataContainer, { duration: 300, offset: { top: -80 } });
        }, 100);
    }
});

function initPagination() {
    var $this = (0, _jquery2.default)(this);
    $this.attr('data-query', true);
    var $dataContainer = (0, _jquery2.default)($this.attr("data-pagination"));
    var lengthMenu = ($this.attr("data-length-menu") || '10,20,50,100').split(',').map(function (i) {
        return parseInt(i, 10);
    });
    var paging = null;
    try {
        paging = JSON.parse($dataContainer.find('[data-paging="true"]').val());
    } catch (e) {}
    if (!paging) paging = { totalCount: 0, pageSize: 20 };

    if (!paging.totalCount) return;

    var page = paging.page || 1;
    var pages = Math.ceil(paging.totalCount / paging.pageSize);
    var items = _jquery2.default.fn.DataTable.ext.pager.simple_numbers(page - 1, pages);
    var itemsHtml = (0, _flatten2.default)(items).map(function (i) {
        switch (i) {
            case 'previous':
                return buttonTemplate(Resx.DataTables.oPaginate_sPrevious, page - 1, page > 1);
            case 'next':
                return buttonTemplate(Resx.DataTables.oPaginate_sNext, page + 1, page < pages);
            case 'ellipsis':
                return buttonTemplate('&#x2026;');
            default:
                if (typeof i === 'number' && !isNaN(i)) {
                    var p = i + 1;
                    return buttonTemplate(p, p, p !== page, p === page);
                }
                break;
        }
        return '';
    }).join('');

    var info = ($this.attr('data-pagination-template-info') || Resx.DataTables.sInfo).replace('_START_', (page - 1) * paging.pageSize + 1).replace('_END_', Math.min(page * paging.pageSize, paging.totalCount)).replace('_TOTAL_', paging.totalCount);

    var pageLengthSelect = '<select class="form-control input-sm length-menu" tabindex="-1">\n                ' + lengthMenu.map(function (i) {
        return '<option value="' + i + '" ' + (i === paging.pageSize ? 'selected' : '') + '>' + i + '</option>';
    }) + '\n            </select>';

    $this.html('<div class="dataTables_wrapper ">\n        <div class="dataTables_length"><label>' + Resx.DataTables.sLengthMenu.replace('_MENU_', pageLengthSelect) + '</label></div>\n        <div class="dataTables_info" role="status" aria-live="polite">' + info + '</div>\n        <div class="dataTables_paginate paging_simple_numbers"><ul class="pagination">' + itemsHtml + '</ul></div>\n    </div>');
}

(0, _jquery2.default)(document).on('change', 'select.length-menu', function () {
    var $this = (0, _jquery2.default)(this);
    _navigator2.default.navigate({ pageSize: $this.val() }, $this.closest('[data-pagination]'));
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/pagination.js
// module id = 582
// module chunks = 0 1